exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-29ea908f]{cursor:default}.tooltip:hover .text[data-v-29ea908f]{display:block}.icon[data-v-29ea908f]{vertical-align:bottom}.text[data-v-29ea908f]{border-radius:15px;display:none;right:10px;top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;width:150px;text-align:center;font-size:0.8em}.text[data-v-29ea908f]:before{content:'';display:block;width:0;height:0;position:absolute;border:10px solid transparent;border-top:10px solid #CFCFCF;left:80%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);bottom:-20px}\n", ""]);

// exports
